import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import FinanceCategoriesApi from '@/services/apiServiceModules/financeCategoriesApi.js'

const financeCategoriesApi = new FinanceCategoriesApi()

export default class FinanceCategoriesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.FINANCE_CATEGORIES, financeCategoriesApi, {
			useCache: true,
		})
	}
}
